<template>
  <div class="stepHeadBox">
    <div class="back">
      <el-button type="text" @click="goRouter">{{data}}</el-button>
    </div>
    <div class="stepMainBox" v-if="authType == 0 ||authType == undefined">
      <!-- <div :class="['stepItem',{'stepItem1': num == 1}]">
        <i :class="[{'el-icon-check': num > 1,'round': num >= 1}]">{{num > 1? '': 1}}</i>
        同意协议
      </div> -->
      <!-- <div class="line"></div> -->
      <div :class="['stepItem',{'stepItem1': num == 2}]">
        <i :class="{'el-icon-check round': num > 2,'round': num >= 2}">{{num > 2? '': 1}}</i>
        填写身份信息及验证
      </div>
      <div class="line"></div>
      <div :class="['stepItem',{'stepItem1': num == 3}]">
        <i :class="{'el-icon-check': num > 3,'round': num >= 3}">{{num > 3? '': 2}}</i>
        完成认证
      </div>
      <div class="line" v-if="canIssueCert"></div>
      <div v-if="canIssueCert" :class="['stepItem',{'stepItem1': num == 4}]">
        <i :class="{'el-icon-check': num > 4,'round': num >= 4}">{{num > 4? '': 3}}</i>
        下证成功
      </div>
    </div>
    <div class="stepMainBox" v-if="authType == 1">
      <!-- <div :class="['stepItem',{'stepItem1': num == 1}]">
        <i :class="[{'el-icon-check': num > 1,'round': num >= 1}]">{{num > 1? '': 1}}</i>
        同意协议
      </div>
      <div class="line"></div> -->
      <div :class="['stepItem',{'stepItem1': num == 2}]">
        <i :class="{'el-icon-check round': num > 2,'round': num >= 2}">{{num > 2? '': 1}}</i>
        企业/组织信息核验
      </div>
      <div v-if="havaAgentAuth" class="line"></div>
      <div v-if="havaAgentAuth" :class="['stepItem',{'stepItem1': num == 3}]">
        <i :class="{'el-icon-check': num > 3,'round': num >= 3}">{{num > 3? '': 2}}</i>
        办理人刷脸验证
      </div>
      <div class="line"></div>
      <div :class="['stepItem',{'stepItem1': num == 4}]">
        <i :class="{'el-icon-check': num > 4,'round': num >= 4}">{{num > 4? '': (havaAgentAuth ? 3: 2)}}</i>
        授权认证
      </div>
      <div class="line"></div>
      <div :class="['stepItem',{'stepItem1': num == 5}]">
        <i :class="{'el-icon-check': num > 5,'round': num >= 5}">{{num > 5? '': (havaAgentAuth ? 4: 3)}}</i>
        完成认证
      </div>
      <div class="line" v-if="canIssueCert"></div>
      <div v-if="canIssueCert" :class="['stepItem',{'stepItem1': num == 6}]">
        <i :class="{'el-icon-check': num > 6,'round': num >= 6}">{{num > 6? '': (havaAgentAuth ? 5: 4)}}</i>
        下证成功
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    const pageConfig = (this.$store.state.userInfo && this.$store.state.userInfo.pageConfig) || {}
    return {
      data: '< ' + (pageConfig.returnText || '返回'),
      canIssueCert: this.$store.state.userInfo.canIssueCert,
      havaAgentAuth: this.$store.state.userInfo.havaAgentAuth
    }
  },
  props: ['num', 'authType'],
  methods: {
    goRouter() {
      window.location.href = this.$store.state.userInfo.preWebUrl
    }
  }
}
</script>
<style lang="scss" scoped>
.stepHeadBox {
  height: 50px;
  background: #fff;
  border-bottom: 1px solid #eceef1;
  display: flex;
  justify-content: center;
  align-content: center;
  position: relative;
  .back {
    position: absolute;
    left: 20px;
    top: 2px;
  }
  .stepMainBox {
    display: flex;
    justify-content: center;
    align-content: center;
  }
  .stepItem {
    line-height: 50px;
    font-size: 14px;
    color: #929292;
    i {
      width: 24px;
      height: 24px;
      display: inline-block;
      background: #ffffff;
      border: 1px solid #e8e8e8;
      border-radius: 12px;
      text-align: center;
      line-height: 22px;
    }

    .round {
      background: #1c67f3;
      background: var(--main-bg-color);
      color: #fff;
    }
    .el-icon-check {
      background: #fff;
      color: #1c67f3;
      color: var(--main-bg-color);
      border: 1px solid #1c67f3;
      border: 1px solid var(--main-bg-color);
    }
    &.stepItem1 {
      color: #333;
    }
  }
  .line {
    width: 10px;
    height: 10px;
    margin: 0 20px;
    position: relative;
    &:after {
      content: '';
      display: inline-block;
      border: 6px solid transparent;
      border-left-color: #fff;
      position: absolute; /*微调位置*/
      top: 19px;
      left: -1px;
      height: 0;
    }
    &::before {
      content: '';
      display: inline-block;
      border: 6px solid transparent;
      border-left-color: #929292;
      position: absolute; /*微调位置*/
      top: 19px;
      left: 0px;
      height: 0;
    }
  }
}
</style>